import { NgModule } from '@angular/core';
import { PieceShippingMethodsRenderComponent } from './render/piece-shipping-methods-render.component';
import { SharedModule } from 'shared/shared.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { SharedComponentsModule } from 'extensions/oy/shared-components/shared-components.module';
import { ShippingService } from 'idt-ecommerce-api/shipping/shipping.service';

export const pieceShippingMethodsCmsModuleEntryComponents = [
  PieceShippingMethodsRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    SharedComponentsModule,
  ],
  declarations: [
    ...pieceShippingMethodsCmsModuleEntryComponents
  ],
  providers: [
    ShippingService
  ],
  entryComponents: pieceShippingMethodsCmsModuleEntryComponents,
})
export class PieceShippingMethodsRenderModule { }

export default pieceShippingMethodsCmsModuleEntryComponents;
